export function useColorService({ onCodeColorChange, onBackgroundColorChange, onFinderPatternColorChange, }) {
    const handleColorChange = (color) => {
        onCodeColorChange(color);
    };
    const handleBackgroundColorChange = (color) => {
        onBackgroundColorChange(color);
    };
    const handleFinderPatternColorChange = (color) => {
        onFinderPatternColorChange(color);
    };
    return {
        handleColorChange,
        handleBackgroundColorChange,
        handleFinderPatternColorChange,
    };
}
//# sourceMappingURL=useColorService.js.map